import * as React from 'react';

export function SvgMicrosoftWord(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_214)">
        <path
          d="M21.1474 3H7.50368C7.03283 3 6.65112 3.38981 6.65112 3.87068V7.75L14.5581 10.125L22 7.75V3.87068C22 3.38981 21.6183 3 21.1474 3Z"
          fill="#41A5EE"
        />
        <path
          d="M22 7.75H6.65112V12.5L14.5581 13.925L22 12.5V7.75Z"
          fill="#2B7CD3"
        />
        <path
          d="M6.65112 12.5V17.25L14.093 18.2L22 17.25V12.5H6.65112Z"
          fill="#185ABD"
        />
        <path
          d="M7.50368 22H21.1474C21.6183 22 22 21.6102 22 21.1293V17.25H6.65112V21.1293C6.65112 21.6102 7.03283 22 7.50368 22Z"
          fill="#103F91"
        />
        <path
          opacity="0.1"
          d="M12.3102 6.79999H6.65112V18.675H12.3102C12.7804 18.6734 13.1612 18.2845 13.1628 17.8043V7.67067C13.1612 7.19045 12.7804 6.80155 12.3102 6.79999Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8451 7.27499H6.65112V19.15H11.8451C12.3153 19.1484 12.6961 18.7595 12.6976 18.2793V8.14567C12.6961 7.66546 12.3153 7.27656 11.8451 7.27499Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8451 7.27499H6.65112V18.2H11.8451C12.3153 18.1984 12.6961 17.8095 12.6976 17.3293V8.14567C12.6961 7.66546 12.3153 7.27656 11.8451 7.27499Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.38 7.27499H6.65112V18.2H11.38C11.8502 18.1984 12.231 17.8095 12.2325 17.3293V8.14567C12.231 7.66546 11.8502 7.27656 11.38 7.27499Z"
          fill="black"
        />
        <path
          d="M2.85256 7.27499H11.38C11.8509 7.27499 12.2326 7.66481 12.2326 8.14567V16.8543C12.2326 17.3352 11.8509 17.725 11.38 17.725H2.85256C2.3817 17.725 2 17.3352 2 16.8543V8.14567C2 7.66481 2.3817 7.27499 2.85256 7.27499Z"
          fill="url(#paint0_linear_14_214)"
        />
        <path
          d="M5.49864 13.9526C5.51538 14.087 5.52654 14.2038 5.53166 14.3041H5.55119C5.55863 14.2091 5.57413 14.0946 5.5977 13.9606C5.62127 13.8267 5.64251 13.7135 5.66142 13.621L6.55817 9.66996H7.7177L8.64793 13.5616C8.70198 13.8036 8.74067 14.0489 8.76375 14.296H8.7791C8.79644 14.0566 8.82876 13.8186 8.87585 13.5835L9.61771 9.66806H10.6731L9.3698 15.3301H8.13677L7.25305 11.5804C7.22748 11.4726 7.19818 11.3315 7.16608 11.1581C7.13398 10.9847 7.11399 10.8579 7.10608 10.7781H7.09073C7.0805 10.8703 7.06049 11.0071 7.03072 11.1885C7.00096 11.37 6.97708 11.5042 6.95909 11.5913L6.12839 15.3291H4.87443L3.56421 9.66995H4.63862L5.44653 13.6291C5.46468 13.7103 5.48189 13.8186 5.49864 13.9526Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14_214"
          x1="3.7776"
          y1="6.59467"
          x2="10.6678"
          y2="18.2798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2368C4" />
          <stop offset="0.5" stopColor="#1A5DBE" />
          <stop offset="1" stopColor="#1146AC" />
        </linearGradient>
        <clipPath id="clip0_14_214">
          <rect
            width="20"
            height="19"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
